import React from 'react';

function StatsSection({ stats }) {
  return (
    <section className="stats" data-testid="stats-section">
      <div className="stats-container">
        {stats.map((stat, index) => (
          <div key={index} className="stat-item" data-testid={`stat-item-${index}`}>
            <div className="stat-number">{stat.value}</div>
            <div className="stat-label">{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default StatsSection;
